import { render, staticRenderFns } from "./PayQrCode.vue?vue&type=template&id=bf905bdc&scoped=true"
import script from "./PayQrCode.vue?vue&type=script&lang=js"
export * from "./PayQrCode.vue?vue&type=script&lang=js"
import style0 from "./PayQrCode.vue?vue&type=style&index=0&id=bf905bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf905bdc",
  null
  
)

export default component.exports